
import { createContext } from "react";

const ThemeContext = createContext({
  darkMode: false,
});

export default ThemeContext;
